const filter = require('lodash/filter')

// 控制网盘的页面,由于几乎所有的网盘列表都使用的同一个页面,所以在进入该控制器的
// 时候需要初始化,即init函数;
// init 函数通过fid来判断进入的状态

module.exports = ['$scope', '$ionicLoading', 'netFolderService', '$state',
  '$stateParams', '$ionicActionSheet', '$ionicPopup', '$ionicPopover',
  '$ionicBackdrop', '$utils', '$translate', '$ionicNavBarDelegate', '$phoneModal',
  '$ionicHistory', '$ionicConfig', '$timeout', '$ionicScrollDelegate', 'User', 'LocalStorage', '$q', '$rootScope',
  function ($scope, $ionicLoading, netFolderService, $state,
    $stateParams, $ionicActionSheet, $ionicPopup, $ionicPopover,
    $ionicBackdrop, $utils, $translate, $ionicNavBarDelegate, $phoneModal,
    $ionicHistory, $ionicConfig, $timeout, $ionicScrollDelegate, User, LocalStorage, $q, $rootScope) {
    $scope.uploadList = []
    $scope.isEmpty = false // 该目录是否为空
    $scope.folderType = $stateParams.type || ''
    $scope.newFolder = {}
    $scope.folderData = {}
    $scope.rootId = 0
    const loadlimit = 20 // 分段加载的数量
    // 初始化

    /** /0/xxx/xxx */
    const matchPath = /(\/([a-z0-9_\-.]+))$/g.exec($stateParams.path)
    $scope.path = $stateParams.path
    // 上一个页面的路径
    $scope.previousPath = function () {
      const perNFListBack = LocalStorage.getItem('perNFListBack')
      if (Object.keys(perNFListBack).length !== 0) {
        LocalStorage.removeItem('perNFListBack')
        return perNFListBack.page + '(' + JSON.stringify(perNFListBack.params) + ')'
      } else {
        const previous = $stateParams.path.replace(new RegExp(matchPath[1]), '')
        return previous ? 'frame.nfList({ type: \'' + $scope.folderType + '\', path: \'' + previous + '\' })' : 'frame.netFolder()'
      }
    }

    function isCurrentPathLevelsLessThanMaxLevels() {
      return ($stateParams.path.match(/\/([a-z0-9_\-.]+)/ig).length || 0) < User.getConfig()['$ajc'].nf.limitFileCount
    }

    init(matchPath[2], $scope.folderType)

    // 初始化页面
    function init(fid, type) {
      $scope.fileList = []
      // 当fid<0时进入根目录的选择
      fid = parseInt(fid || 0)
      if (type === 'ent') {
        initEnterpriseNetFolder(fid)
      } else if (type === 'per') {
        initPersonalNetFolder(fid)
      } else if (type === 'ftc') {
        initFileTransitCenter()
      } else if (type === 'rel') {
        $scope.attachmentList = []
        initRelatedAccessory()
      }
    }
    // 初始化企业网盘
    function initEnterpriseNetFolder(fid) {
      $scope.isEntFolder = true
      _getFolders(fid, {isEntFolder: true})
    }
    // 初始化个人网盘
    function initPersonalNetFolder(fid) {
      _getFolders(fid, {})
    }
    // 初始化文件中转站
    function initFileTransitCenter() {
      $scope.curFolderName = $translate.instant('NETFOLDER.FILE_TRANSIT_CENTER')
      $scope.isEnabledMoreOption = false
      $scope.trsStatus = {
        limitTrsFileSize: User.getConfig().$ajc.nf.limitTrsFileSize, // 总容量
        trsFileCount: User.getConfig().$ajc.nf.trsFileCount, // 文件数量
        trsFileSize: User.getConfig().$ajc.nf.trsFileSize // 已用容量
      }
      $scope.totalFileCount = $translate.instant('NETFOLDER.TOTALFILE', {count: $scope.trsStatus.trsFileCount})
      _getFileList(9, {order: 'date'})
    }
    function _getFolders(fid, options) {
      /* 区分是否是企业网盘 */
      $scope.loadTips = ''
      $scope.isLoading = true
      const isRoot = fid === $scope.rootId
      let resultVar
      if (options.isEntFolder) {
        $scope.isEnabledMoreOption = false
        netFolderService.getEntFolderList(fid, options).then(function (data) {
          resultVar = data.var
          $scope.curFolderName = resultVar.name ? $utils.$html.encode(resultVar.name) : $translate.instant('NETFOLDER.ENT_NETFOLDER')
          $scope.folderList = resultVar.children || []
          $scope.folderId = resultVar.id
          if (fid === 0) {
            $scope.rootId = $scope.folderId
          }
          $scope.parentFolderId = resultVar.parentId || 0
          /* 读取文件夹成功后读取file */
          const opt = {
            start: 0,
            limit: loadlimit,
            uid: netFolderService.getUid()
          }
          _getFileList($scope.folderId, opt)
          resultVar.adminType = resultVar.adminType || ''
          resultVar.accessRole = resultVar.accessRole || ''
          const isFolderAdmin = resultVar.adminType.toLowerCase() === 'folderadmin'
          const hasWritePermission = resultVar.accessRole.toLowerCase().indexOf('w') !== -1
          const modifiable = resultVar['modifiable']
          const deletable = resultVar['deletable']

          const isOA = User.getConfig()['$ajc'].user.isOA

          // 代码逻辑基于 webmail enfList.jsp nfListDetails.tag 进行调整
          $scope.isEnableUpload = !isRoot && (isOA || hasWritePermission)
          $scope.isEnableCreateFolder = (isOA || (isFolderAdmin && !isRoot)) &&
                        isCurrentPathLevelsLessThanMaxLevels()
          $scope.isEnableDeleteFolder = (isRoot && isOA) || (!isRoot && isFolderAdmin && deletable)
          $scope.isEnableRenameFolder = !isRoot && (isOA || isFolderAdmin) && modifiable
          $scope.isEnabledMoreOption = $scope.isEnableUpload || $scope.isEnableCreateFolder ||
                        $scope.isEnableDeleteFolder || $scope.isEnableRenameFolder
        }, function (_) {
          $scope.isLoading = false
        })
      } else {
        netFolderService.getFolderList(fid, options).then(function (data) {
          if (data.code === 'S_OK') {
            resultVar = data.var
            $scope.curFolderName = resultVar.name ? $utils.$html.encode(resultVar.name) : $translate.instant('NETFOLDER.PERSONAL_NETFOLDER')
            $scope.folderList = resultVar.children || []
            $scope.folderId = resultVar.id
            if (fid === 0) {
              $scope.rootId = $scope.folderId
            }
            const isSys = resultVar.mode && resultVar.mode.toLowerCase() === 's'
            $scope.isEnabledMoreOption = $scope.isEnableUpload = true
            $scope.isEnableCreateFolder = isCurrentPathLevelsLessThanMaxLevels()
            $scope.isEnableRenameFolder = !isSys && !isRoot
            $scope.isEnableDeleteFolder = !isRoot

            // 个人网盘的不会返回该属性,所以删除文件之后只能返回根目录
            $scope.parentFolderId = resultVar.parentId || 0
            /* 读取文件夹成功后读取file */
            const opt = {
              start: 0,
              limit: loadlimit
            }
            _getFileList($scope.folderId, opt)
          } else {
            console.log('loading folders failed, data.code is: ' + data.code)
          }
        }, function () {
          $scope.isLoading = false
        })
      }
    }
    // 初始化来往附件
    function initRelatedAccessory() {
      $scope.curFolderName = $translate.instant('NETFOLDER.RELATED_ACCESSORY')
      _getAttachmentList({start: 0, limit: loadlimit})
    }
    function _getFileList(fid, options) {
      $scope.noMoreFile = 'true'
      $scope.isLoading = true
      netFolderService.listFiles(fid, options).then(function (data) {
        if (data.code === 'S_OK') {
          if (data.var) {
            for (let i = 0; i < data.var.length; i++) {
              data.var[i].formattype = $utils.$attachment.getIconClass(data.var[i].name, data.var[i].contentType)
              if ($scope.folderType === 'ftc') {
                data.var[i].formatRemaintime = getFormatRemaintime(data.var[i].misc.remaintime)
              }
            }
            $scope.fileList = $scope.fileList.concat(data.var) || []
            $ionicScrollDelegate.resize()
          }
          if ($scope.folderType !== 'ftc') {
            $scope.isEmpty = $scope.folderList.length === 0 && $scope.fileList.length === 0
          } else {
            $scope.isEmpty = $scope.fileList.length === 0
          }
          if (data['var'].length === loadlimit) {
            $scope.noMoreFile = false
          }
        }
      }, function () {
      }).finally(function() {
        $scope.isLoading = false
      })
    }

    function _getAttachmentList(options) {
      $scope.isLoading = true
      netFolderService.listAttachments(options).then(function(data) {
        if (data && data.code === 'S_OK') {
          data.var.forEach(function(item) {
            item.formattype = $utils.$attachment.getIconClass(item.attn, item.contentType)
          })
          $scope.attachmentList = $scope.attachmentList.concat(data.var) || []
          $scope.isEmpty = $scope.attachmentList.length === 0
          $scope.noMoreAttachment = $scope.attachmentList.length === data.total
          $ionicScrollDelegate.resize()
        }
      }, function(error) {
        console.log(error)
      }).finally(function() {
        $scope.isLoading = false
      })
    }

    /* 控制器方法 */
    $scope.doRefresh = function () {
      $scope.loadTips = '更多'
      init($scope.folderId, $scope.folderType)
      $scope.$broadcast('scroll.refreshComplete')// 广播该事件，让读取进度条停止
    }

    $scope.loadMore = function () {
      const options = {
        start: $scope.fileList.length,
        limit: loadlimit
      }
      if ($scope.isEntFolder) {
        options.uid = netFolderService.getUid()
      }
      _getFileList($scope.folderId, options)
    }
    $scope.moreAttachment = function() {
      $scope.isLoadingMore = true
      const options = {
        start: $scope.attachmentList.length,
        limit: loadlimit
      }
      netFolderService.listAttachments(options).then(function(data) {
        if (data && data.code === 'S_OK') {
          data.var.forEach(function(item) {
            item.formattype = $utils.$attachment.getIconClass(item.attn, item.contentType)
          })
          $scope.attachmentList = $scope.attachmentList.concat(data.var) || []
          $scope.isEmpty = $scope.attachmentList.length === 0
          $scope.noMoreAttachment = $scope.attachmentList.length === data.total
          $ionicScrollDelegate.resize()
        }
      }, function(error) {
        console.log(error)
      }).finally(function() {
        $scope.isLoadingMore = false
      })
    }
    $ionicPopover.fromTemplateUrl('file-popover.html', {
      scope: $scope
    }).then(function (popover) {
      $scope.popover = popover
    })

    /* 处理更多选项按钮 */
    $scope.doMoreOperation = function ($event) {
      if ($scope.folderType === 'ent') {
        LA.track('A3C1B3')
      } else if ($scope.folderType === 'per') {
        LA.track('A3C2B3')
      }
      $scope.popover.show($event)
    }

    $scope.closePopover = function () {
      $scope.popover.hide()
    }

    $scope.createFolder = function () {
      if ($scope.folderType === 'ent') {
        LA.track('A3C1B302')
      } else if ($scope.folderType === 'per') {
        LA.track('A3C2B302')
      }
      $scope.closePopover()
      $scope.newFolder = {}
      $scope.newFolderModal = $phoneModal.fromTemplate(require('views/netFolder/newFolderModal.html'), {
        scope: $scope,
        animation: 'slide-in-right'
      })
      $utils.$modalFunc.prepareModalBack($scope.newFolderModal)
      $scope.newFolderModal.show()
    }

    /* 此处不用基本类型存储的意义在于js的原型继承, 此处会生成独立的scope,基本数据类型无法使得
         处于headbar和content 两个不同scope的变量共享 */
    $scope.cancelNewFolder = function () {
      $scope.newFolderModal.remove()
      $scope.newFolder.name = ''
    }

    $scope.confirmCreateFolder = function (folderName) {
      netFolderService.createFolder($scope.folderId, $scope.folderType, folderName).then(function (data) {
        if (data.code === 'S_OK') {
          init($scope.folderId, $scope.folderType)
          showNotify($translate.instant('NETFOLDER.CREATE_FOLDER_SUC'))
          $scope.newFolder.name = ''
          $scope.newFolderModal.remove()
        }
      })
    }

    /* 删除文件夹 */
    $scope.deleteFolder = function () {
      $scope.closePopover()
      $ionicActionSheet.show({
        titleText: $translate.instant('NETFOLDER.CLEAR_FOLDER_TIPS'),
        destructiveText: "<p class='actionText'>" + $translate.instant('OP.CLEAR') + '</p>',
        cancelText: $translate.instant('OP.CANCEL'),
        destructiveButtonClicked: function () {
          const folderIds = []
          $scope.folderList.forEach(function (folder) {
            folderIds.push(folder.id)
          })
          const fileIds = []
          $scope.fileList.forEach(function (file) {
            fileIds.push(file.id)
          })
          const deleteFolders = netFolderService.deleteFolder_R(folderIds, $scope.folderType)
          const deleteFiles = netFolderService.deleteFiles(fileIds, $scope.folderType)
          $q.all([deleteFolders, deleteFiles]).then(function () {
            // 由于目前只有清空操作，没有整个文件夹删除操作，故屏蔽原来的代码
            //    _refreshBackToView();
            init($scope.folderId, $scope.folderType)
            $utils.$notify.set({message: $translate.instant('NETFOLDER.NF_CLEAR_SUC')})
          })
          return true
        },
        cancel: function () {
          // to do when cancel
        }
      })
    }

    function _refreshBackToView() { //eslint-disable-line
      const backView = $ionicHistory.backView()
      const backViewStateId = [backView.stateId]
      $ionicHistory.clearCache(backViewStateId)
      // 异步是由于clearCache也是异步
      $timeout(function () {
        $state.go(backView.stateName, backView.stateParams)
      }, 0)
    }
    function getFormatRemaintime(remainTime) {
      let days, hours
      if (remainTime % 86400000 > 0) {
        days = Math.floor(remainTime / 86400000)
      } else {
        days = 0
      }
      hours = Math.ceil(remainTime / 3600000 - (24 * days))
      if (hours === 24) {
        days += 1
        hours = 0
      }
      const time = $translate.instant('NETFOLDER.VALID_TIME', {days: days, hours: hours})
      return time
    }

    /* 重命名文件夹 */
    $scope.renameFolder = function () {
      $scope.closePopover()
      $scope.folderData.name = $utils.$html.decode($scope.curFolderName)
      $scope.renameFolderModal = $phoneModal.fromTemplate(require('views/netFolder/renameFolderModal.html'), {
        scope: $scope,
        animation: 'fade-in-up'
      })
      $utils.$modalFunc.prepareModalBack($scope.renameFolderModal)
      $scope.renameFolderModal.show()
    }

    $scope.cancelRenameFolder = function () {
      $scope.renameFolderModal.remove()
      $scope.folderData.name = ''
    }

    $scope.confirmRenameFolder = function (newFoldername) {
      if (newFoldername !== $scope.curFolderName) {
        netFolderService.reNameFolder($scope.folderId, newFoldername, $scope.folderType)
          .then(function (data) {
            init($scope.folderId, $scope.folderType)
            $ionicHistory.clearCache()
            showNotify($translate.instant('NETFOLDER.RENAME_SUC'))
            $scope.folderData.name = ''
            $scope.renameFolderModal.remove()
          })
      } else if (newFoldername == $scope.curFolderName) {
        showNotify($translate.instant('NETFOLDER.FOLDER_NAME_NO_CHANGE'))
      }
    }

    /* 搜索 */
    $scope.openSearch = function () {
      if ($scope.folderType === 'ent') {
        LA.track('A3C1B2')
      } else if ($scope.folderType === 'per') {
        LA.track('A3C2B2')
      }
      setTimeout(function () {
        let modalName = ''
        if ($scope.folderType === 'rel') {
          modalName = 'searchAttachmentsModal.html'
        } else {
          modalName = 'searchModal.html'
        }
        $scope.searchModal = $phoneModal.fromTemplate(require(`views/netFolder/${modalName}`), {
          scope: $scope,
          animation: 'scale-in'
        })
        $scope.searchModal.show()
        const currentStateId = $ionicHistory.currentView().stateId
        const clearWatch = $scope.$watch(function () {
          return $ionicHistory.currentView().stateId
        }, function (newValue) {
          console.log('change' + newValue)
          if (newValue === currentStateId && $scope.searchModal) {
            $scope.searchModal.show()
          } else if (!$scope.searchModal) {
            clearWatch()
          }
        })

        // 打开搜索的modal后需要监听取消搜索的事件, 返回的函数用于取消事件监听;
        const stopSubscribe = $scope.$on('closeSearchModal', function (event, isRemove) {
          if ($scope.searchModal) {
            if (isRemove) {
              $scope.searchModal.remove()
              stopSubscribe() // 停止监听该事件
              clearWatch()
            } else {
              $scope.searchModal.hide()
            }
          }
        })
      }, 0)
    }

    /* 文件上传是调用upload接口,然后通过写信的附件上传在转移到网盘,详细介绍见
     * jira: APP-1002
     */
    $scope.uploadFile = function (event) {
      if ($scope.folderType === 'ent') {
        LA.track('A3C1B301')
      } else if ($scope.folderType === 'per') {
        LA.track('A3C2B301')
      }
      listeningFileSelect(event.target)
      $scope.closePopover()
    }

    function listeningFileSelect(target) {
      target.onchange = function () {
        sendFiles(this.files)
        target.value = null
      }
    }

    /* 上传文件的逻辑比较繁琐, 首先构造一个file对象(对原来的file对象的属性扩充), 然后调用prepareUpload获取attachmentId和composeId
     * 如果检查通过,则调用upload方法上传, 传成功后调用moveTofolder, 将附件转移到网盘 ;
     * 参考webmail的实现方法, 由于api文档不全无法知道是否直接上传到网盘的接口
     */
    function sendFiles(files) {
      const length = files.length
      for (let i = 0; i < length; i++) {
        const file = files[i]
        $scope.uploadList.unshift(file)
        file.uploadProgress = 0
        // 将日期转换成相应格式
        file.creationDate = $utils.$date.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss')
        file.uploadTips = $translate.instant('NETFOLDER.NF_WAITTOUPLOAD')
        const dataForm = new FormData()
        dataForm.append('file', file)
        const info = {
          composeId: $scope.folderId,
          size: file.size,
          fileName: file.name,
          folderType: $scope.folderType
        }
        netFolderService.prepareUpload(info)
          .then(function (data) {
            file.uploadTips = '' // 开始上传没有提示
            const attachmentId = data['var'].attachmentId
            const info = {
              composeId: $scope.folderId,
              offset: 0,
              attachmentId: attachmentId,
              folderType: $scope.folderType
            }
            // 准备成功 开始上传
            netFolderService.upload(file, info)
              .then(function (data) {
                // 上传成功,转移到网盘
                const attachmentId = data['var'].attachmentId
                const info = {
                  composeId: $scope.folderId,
                  fileName: file.name,
                  attachmentId: attachmentId,
                  folderType: $scope.folderType
                }
                netFolderService.moveToFolder(info)
                  .then(function () {
                    file.uploadProgress = 100
                    const index = $scope.uploadList.indexOf(file)
                    $scope.uploadList.splice(index, 1)
                    init($scope.folderId, $scope.folderType)// suc
                    // if in webview , use toast to mention the user
                    showNotify($translate.instant('NETFOLDER.UPLOAD_SUC'))
                  }, function () {
                    // 移动到网盘失败
                    file.uploadTips = $translate.instant('NETFOLDER.NF_UPLOADFAILED')
                  })
              }, function () {
                // 上传失败
                file.uploadTips = $translate.instant('NETFOLDER.NF_UPLOADFAILED')
              }, function (progress) {
                file.uploadProgress = progress
              })
          }, function (errorType) {
            // 准备上传失败: (1).文件大小超过限制
            console.log(errorType)
            if (errorType == 'overflow') {
              const index = $scope.uploadList.indexOf(file)
              $scope.uploadList.splice(index, 1)
            } else {
              file.uploadTips = $translate.instant('NETFOLDER.NF_UPLOADFAILED')
            }
          })
      }
    }

    /* 取消文件上传 */
    $scope.uploadOption = function (file) {
      const xhr = netFolderService.getUploadXhr(file)
      console.log(xhr)
      if (file.uploadTips == $translate.instant('NETFOLDER.NF_UPLOADFAILED') ||
                file.uploadTips == $translate.instant('NETFOLDER.NF_WAITTOUPLOAD')) {
        // 当文件下载上传失败的时候,即tips显示为失败时,提供重新上传和删除功能;
        $ionicActionSheet.show({
          buttons: [
            {text: "<p class='actionText'>" + $translate.instant('NETFOLDER.REUPLOADFILE') + '</p>'},
          ],
          destructiveText: "<p class='actionText'>" + $translate.instant('OP.DELETE') + '</p>',
          cancelText: $translate.instant('OP.CANCEL'),
          destructiveButtonClicked: function () {
            // 点击取消上传
            _cancleUploadFile(file)
            showNotify($translate.instant('NETFOLDER.NF_DELETE_SUC'))
            return true
          },
          cancel: function () {
            // to do when cancel
          },
          buttonClicked: function (index) {
            switch (index) {
              case 0:
                _cancleUploadFile(file)
                sendFiles([file])
                break
                            // no default
            }
            return true
          }
        })
      } else if (xhr) {
        $ionicActionSheet.show({
          destructiveText: "<p class='actionText'>" + $translate.instant('NETFOLDER.NF_CANCEL_UPLOAD') + '</p>',
          cancelText: $translate.instant('OP.CANCEL'),
          destructiveButtonClicked: function () {
            // 点击取消上传
            xhr.resolve()
            _cancleUploadFile(file)
            showNotify($translate.instant('NETFOLDER.CANCEL_UPLOAD_SUC'))
            return true
          },
          cancel: function () {
            // to do when cancel
          }
        })
      }
    }

    function _cancleUploadFile(file) {
      netFolderService.clearUploadXhr(file)
      const index = $scope.uploadList.indexOf(file)
      $scope.uploadList.splice(index, 1)
    }

    function showNotify(message) {
      if ($scope.netFolderNotify) {
        $scope.netFolderNotify.show(message)
      } else {
        $scope.netFolderNotify = $utils.$notify.set({message: message})
      }
    }
    // 当前网盘文件夹是否是文件中心唯一的子项目， 根据此决定显示侧边栏按钮或者返回按键
    $scope.isCurrentNetFolderTheOnlyItemOfNetFolders = function() {
      const allSubItems = [
        { item: { state: 'frame.nfList', param: { type: 'ent', path: '/0' } }, isEnable: $rootScope.hasEntNetfolder && $scope.settings.featureControl.fileCenter.enableEnterpriseNetworkDisk },
        { item: { state: 'frame.nfList', param: { type: 'per', path: '/0' } }, isEnable: $rootScope.hasPerNetfolder && $scope.settings.featureControl.fileCenter.enablePersonalNetworkDisk },
        { item: { state: 'frame.nfList', param: { type: 'ftc', path: '/0' } }, isEnable: $scope.settings.featureControl.fileCenter.enableFileTransitCenter },
        { item: { state: 'frame.nfList', param: { type: 'rel', path: '/0' } }, isEnable: $scope.settings.featureControl.fileCenter.enableRelatedAccessory },

      ]
      const enableSubItems = filter(allSubItems, item => item.isEnable)
      return enableSubItems.length === 1
    }
  }]



// WEBPACK FOOTER //
// ./src/js/netFolder/nfListCtrl.js